import firebase from 'firebase'

// Production
var config = {
  apiKey: 'AIzaSyAN93t5tKf6wgSoiuhY4ubPionRyQkiOyk',
  authDomain: 'one-business-1ca39.firebaseapp.com',
  databaseURL: 'https://one-business-1ca39.firebaseio.com',
  storageBucket: 'gs://one-business-1ca39.appspot.com',
  messagingSenderId: '261409205383'
}

// testing
  // var config = {
  //   apiKey: 'AIzaSyCnUbXCE4MRZq2_VR5dTLJjN60-4jaEq9U',
  //   authDomain: 'one-bussiness-testing.firebaseapp.com',
  //   databaseURL: 'https://one-bussiness-testing.firebaseio.com/',
  //   storageBucket: 'gs://one-bussiness-testing.appspot.com',
  //   messagingSenderId: '335842623685'
  // }

firebase.initializeApp(config)

export const cfirebase = firebase

export default {
  database: firebase.database(),
  firebase
}



// WEBPACK FOOTER //
// ./src/services/firebase.js